export default __webpack_public_path__ + "static/media/024-sailboat.64a030dc.svg";